import { CommentOutlined, CommentsDisabledOutlined } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { Button } from "~/common/mui";

export const ToggleCommentButton = ({ open, onClick }: { open?: boolean; onClick?: () => void }) => {
  const { t } = useTranslation();
  const icon = open ? <CommentsDisabledOutlined /> : <CommentOutlined />;
  const label = t(`cart.${open ? "closeComment" : "openComment"}`);

  return (
    <Button variant="text" color="textPrimary" onClick={onClick} startIcon={icon}>
      {label}
    </Button>
  );
};
